import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';

import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import FlyoutModal from '../common/FlyoutModal';
import CartConfirmationItem from '../CartConfirmationItem';
import styles from './CartConfirmationModal.module.scss';
import PrimaryButton from '../common/PrimaryButton';
import {
  getItemsAdded,
  getCustomLineItemsAdded,
} from './CartConfirmationModalUtils';
import messages from './messages';
import {
  FEEL_ATTRIBUTE_NAME,
  FEEL_VARIANT_NAME_COOKIE,
  WARRANTY_CUSTOM_LINE_ITEM_TYPE,
} from '../../utils/common/constants';
import { FLYOUT_MODAL_THEME_CART } from '../common/FlyoutModal/constants';
import { findVariantAttributeByName } from '../../utils/variants';
import { getCookie } from '../../utils/common/common';

const CartConfirmationModal = ({ onCloseModal }) => {
  const { formatMessage, locale } = useIntl();

  const hideFeelCookie = getCookie(FEEL_VARIANT_NAME_COOKIE);
  const hideFeelVariantName = hideFeelCookie?.value === 'hide_feel_variant_test';
  const { lineItems, previousLineItems } = useSelector((state) => state.cart);
  const [lineItemsAdded, setLineItemsAdded] = useState([]);
  const shownRef = useRef(false);


  const warrantyItems = useSelector((state) => {
    const { customLineItems, previousCustomLineItems } = state.cart;

    const addedCustomLineItems = getCustomLineItemsAdded({
      customLineItems,
      previousCustomLineItems,
    });
    return addedCustomLineItems.filter(
      (customLineItem) =>
        customLineItem.custom?.fields?.type === WARRANTY_CUSTOM_LINE_ITEM_TYPE,
    );
  });

  useEffect(() => {
    if (!shownRef.current) {
      const newItems = getItemsAdded(lineItems, previousLineItems);
      if (newItems.length) {
        setLineItemsAdded(newItems);
        shownRef.current = true;
      }
    }
  }, [lineItems, previousLineItems]);

  const continueHandler = () => {
    window.location.href = '/cart';
  };

  const getVariantTitle = (lineItem) => {
    if (
      !!findVariantAttributeByName(lineItem.variant, FEEL_ATTRIBUTE_NAME)
      && hideFeelVariantName) {
      return lineItem.variant.attributes?.find(
        (attribute) => attribute.name === 'size',
      )?.value.label;
    }
    return lineItem.variant.attributes?.find(
      (attribute) => attribute.name === 'title',
    )?.value;
  };

  return (
    <FlyoutModal
      isVisible
      onCloseModal={onCloseModal}
      backButtonLabel={formatMessage(messages.backLabel)}
      subHeader={null}
      theme={FLYOUT_MODAL_THEME_CART}
      title={formatMessage(messages.addedToCart)}
    >
      <div className={styles.wrapper}>
        <div className={styles.content}>
          {lineItemsAdded.map((lineItem) => {
            const associatedWarrantyItems = warrantyItems.filter((item) =>
              item.custom?.fields?.lineItemsIds?.includes(lineItem.id),
            );
            return (
              <div key={lineItem.id}>
                <CartConfirmationItem
                  key={lineItem.id}
                  imageURL={lineItem.variant.images[0]?.url}
                  name={lineItem.name[locale]}
                  productUrl={
                  lineItem.variant.attributes?.find(
                    (attribute) => attribute.name === 'productUrl',
                  )?.value
                }
                  title={getVariantTitle(lineItem)}
                  price={lineItem.price}
                  discount={lineItem.discount}
                  quantity={lineItem.quantity}
                />
                {associatedWarrantyItems.map((warrantyItem) => (
                  <CartConfirmationItem
                    key={warrantyItem.id}
                    imageURL={`${process.env.ASSETS_URL}/images/svg/extend.svg`}
                    name={warrantyItem.name[locale]}
                    title={(
                      <div>
                        <div>
                          {formatMessage(messages.warrantyProduct, {
                            product: lineItem.name[locale],
                          })}
                        </div>
                        <div>
                          {formatMessage(messages.warrantyTerm, {
                            count: warrantyItem.custom?.fields?.warrantyTerm / 12,
                          })}
                        </div>
                      </div>
                  )}
                    price={warrantyItem.totalPrice}
                    quantity={warrantyItem.quantity}
                  />
                ))}
              </div>
            );
          })}
        </div>
        <div className={styles['cart-confirmation-footer']}>
          <PrimaryButton
            title={formatMessage(messages.continue)}
            onClick={continueHandler}
          />
        </div>
      </div>

    </FlyoutModal>
  );
};

CartConfirmationModal.propTypes = {
  onCloseModal: PropTypes.func.isRequired,
};
export default CartConfirmationModal;
